import * as actionTypes from '../actions/actionTypes';

export default function (state = [], action) {
  switch (action.type) {
    case actionTypes.FETCH_SALESREPS_SUCCESS:
      return [...action.salesReps];
    default:
      return state;
  }
}
